import React from "react";
import { inject, observer } from "mobx-react";
import { LightButton, StickyFooterButtons } from "best-common-react";

function OrgAdminFooter(props) {
  const { orgAdminStore } = props.rootStore;
  return (
    <StickyFooterButtons>
      <LightButton onClick={orgAdminStore.save}>Save</LightButton>
    </StickyFooterButtons>
  );
}

export default inject("rootStore")(observer(OrgAdminFooter));
